/* eslint-disable */
(($) => {
    Drupal.behaviors.tooltip = {
      attach(context) {
        if (context === document) {
        $('.toggle-item__label', context).on('click', function(e) {
          $(this).toggleClass('open');
          $(this).next('.toggle-item__content').toggleClass('open');
          if($(this).hasClass('open')) {
            $(this).attr('aria-expanded', 'true');
          } else {
            $(this).attr('aria-expanded', 'false');
          }
        });
  
        // homepage tooltip
        $('.tooltip-item__close').on('click', function (e) {
          e.preventDefault();
          $(this).parent('.toggle-item__content').removeClass('open');
          $(this).parent('.toggle-item__content').prev('.toggle-item__label').removeClass('open');
        });
  
        // Close tooltip by clicking off from it
        $(context).on('click', function (event) {
          // I want every element in my document, except the stuff inside the classes I've defined, to trigger the click event
          if (!$(event.target).closest('.toggle-item__label, .toggle-item__content').length) {
            // This is the stuff I want to happen, to close things, removing open classes, adjusting my aria roles, etc
            $('.toggle-item__label, .toggle-item__content').removeClass('open');
          }
        });
       }
      },
    };
  })(jQuery);